import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  buttonOutline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid 1px #3C419A',
    borderRadius: '15px',
    width: '53px',
    height: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    color: '#3C419A',
  },
  header: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    color: '#000000',
    padding: '10px 8px 10px 20px',
  },
}));
